import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react'
import { MapboxGeoJSONFeature } from 'mapbox-gl'
import { useGenericMapContext } from '@app/contexts/ModuleMapContexts/GenericMapContext'
import {
  GenericMapContextInterface,
  MapProviderProps,
} from '@app/contexts/ModuleMapContexts/GenericMapContext/GenericMapContext.types'

export interface LiveMapContextInterface extends GenericMapContextInterface {
  hoveredFeature: MapboxGeoJSONFeature | null
  setHoveredFeature: Dispatch<SetStateAction<MapboxGeoJSONFeature | null>>
  selectedFeature: MapboxGeoJSONFeature | null
  setSelectedFeature: Dispatch<SetStateAction<MapboxGeoJSONFeature | null>>
  selectedLayerId: string | null
  setSelectedLayerId: Dispatch<SetStateAction<string | null>>
}

export const LiveMapContext = createContext({} as LiveMapContextInterface)

export function LiveMapProvider({ children }: MapProviderProps) {
  const genericMapContext = useGenericMapContext()
  const [hoveredFeature, setHoveredFeature] = useState<MapboxGeoJSONFeature | null>(null)
  const [selectedFeature, setSelectedFeature] = useState<MapboxGeoJSONFeature | null>(null)
  const [selectedLayerId, setSelectedLayerId] = useState<string | null>(null)

  return (
    <LiveMapContext.Provider
      value={{
        ...genericMapContext,
        hoveredFeature,
        setHoveredFeature,
        selectedFeature,
        setSelectedFeature,
        selectedLayerId,
        setSelectedLayerId,
      }}
    >
      {children}
    </LiveMapContext.Provider>
  )
}

export const useLiveMap = () => useContext(LiveMapContext)
